import { render, staticRenderFns } from "./ProductSummary.vue?vue&type=template&id=ad4cd534&scoped=true&"
import script from "./ProductSummary.vue?vue&type=script&lang=js&"
export * from "./ProductSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProductSummary.vue?vue&type=style&index=0&id=ad4cd534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4cd534",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/product_summary.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fbasket%2FProductSummary.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports